function coloringHandler() {
  var getSwatchImage = this.parentElement.querySelector("img").getAttribute("src");
  if (typeof getSwatchImage != "undefined" && getSwatchImage != null && getSwatchImage != "") {
      var productCardElement = this.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
      if (productCardElement.querySelector(".card-media figure").classList.contains("cover")) {
          productCardElement.querySelector(".card-media").classList.add("cover-swatch");
      } else {
          productCardElement.querySelector(".card-media").classList.add("contain-swatch");
      }
      productCardElement.querySelector(".card-media").style.backgroundImage = "url(" + getSwatchImage + ")";
  }
}

function decoloringHandler() {
  var productCardElement = this.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
  productCardElement.querySelector(".card-media").classList.remove("cover-swatch");
  productCardElement.querySelector(".card-media").classList.remove("contain-swatch");
  productCardElement.querySelector(".card-media").style.backgroundImage = "none";
}
document.addEventListener("DOMContentLoaded", function (event) {
  [].forEach.call(document.querySelectorAll('.product-card-swatches-wrapper .product-card-color-swatch-wrapper ul li.has-color a'), function (link) {
      link.addEventListener('mouseover', coloringHandler);
      link.addEventListener('mouseout', decoloringHandler);
  });
  var customLanguageLinks = document.querySelectorAll(".custom-language-links");
  if (customLanguageLinks) {
      customLanguageLinks.forEach(function (el, key) {
          el.querySelectorAll("a").forEach(function (newEl, newKey) {
              newEl.addEventListener('click', function (event) {
                  event.preventDefault();
                  var currentHref = event.target.getAttribute("data-href");
                  var currentURl = window.location.href;
                  if (currentHref == "fi") {
                      if (currentURl.indexOf("fi.ivalo.com") != -1) {

                      } else if (currentURl.indexOf("nl.ivalo.com") != -1) {
                          currentURl = currentURl.replace("nl.ivalo.com", "fi.ivalo.com");
                      } else {
                          currentURl = currentURl.replace("ivalo.com", "fi.ivalo.com");
                      }
                  } else if (currentHref == "nl") {
                      if (currentURl.indexOf("fi.ivalo.com") != -1) {
                          currentURl = currentURl.replace("fi.ivalo.com", "nl.ivalo.com");
                      } else if (currentURl.indexOf("nl.ivalo.com") != -1) {

                      } else {
                          currentURl = currentURl.replace("ivalo.com", "nl.ivalo.com");
                      }
                  } else if (currentHref == "en") {
                      if (currentURl.indexOf("fi.ivalo.com") != -1) {
                          currentURl = currentURl.replace("fi.ivalo.com", "ivalo.com");
                      } else if (currentURl.indexOf("nl.ivalo.com") != -1) {
                          currentURl = currentURl.replace("nl.ivalo.com", "ivalo.com");
                      } else {

                      }
                  }
                  window.location.href = currentURl;
              });
          });
      });
  }

  /* Search button Click Event */
  document.querySelector(".header-item__link.medium-up--hide.search-button").addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelector("#drawer-search input").click();
  });

  var boostPFSFilterButton = document.querySelector(".boost-pfs-filter-custom-button a");
  if (boostPFSFilterButton) {
      boostPFSFilterButton.addEventListener("click", function() {
          if (window.innerWidth < 768) {
              document.body.classList.add("boost-pfs-filter-tree-open-body");
          }
      });
  }

  var drawerCollFilterButton = document.querySelector("#drawer-collection-filter .drawer-header a");
  if (drawerCollFilterButton) {
      drawerCollFilterButton.addEventListener("click", function() {
          document.body.classList.remove("boost-pfs-filter-tree-open-body");
      });
  }

  /* Read More - Read Less */
  var readMoreLinks = document.querySelectorAll(".read-more-less-wrapper a");
  if (readMoreLinks.length > 0) {
      readMoreLinks.forEach(function(link) {
          link.addEventListener("click", function(e) {
              e.preventDefault();
      
              var parent = this.parentElement;
              var moreText = parent.getAttribute("data-more");
              var lessText = parent.getAttribute("data-less");
              var getCurrentLanguage = document.body.getAttribute("data-current-language");
              var descriptionText = document.querySelector(".description-translation-text");
      
              var grandParent = parent.parentElement;
              if (grandParent.classList.contains("active")) {
                  grandParent.classList.remove("active");
                  this.textContent = moreText;
      
                  if (descriptionText && descriptionText.querySelector("a")) {
                      if (getCurrentLanguage === "fi" || getCurrentLanguage === "nl") {
                          descriptionText.style.display = "none";
                      }
                  }
              } else {
                  grandParent.classList.add("active");
                  this.textContent = lessText;
      
                  if (descriptionText && descriptionText.querySelector("a")) {
                      if (getCurrentLanguage === "fi" || getCurrentLanguage === "nl") {
                          descriptionText.style.display = "block";
                      }
                  }
              }
          });
      });
  }

  // Cart Drawer Notice
  const productFormButton = document.querySelector('button.product-form__submit[type="submit"][name="add"]');
  if (productFormButton) {
      productFormButton.addEventListener('click', () => {
          setTimeout(() => {
              checkCartForDifferentVariants();
          }, 500);
      });
  }

  /* klaviyo-reviews link remove if no review */
  setTimeout(() => {
      var reviewsWrapper = document.querySelector('.product-klaviyo-reviews-wrapper');
      if (reviewsWrapper) {
          var reviewsAllContainer = document.querySelector('.reviews_all_container');
          if (!reviewsAllContainer) {
              var links = reviewsWrapper.querySelectorAll('a');
              links.forEach(link => link.removeAttribute('href'));
          }
      }
  }, 2000);

  /* Product Description read more hide-show */
  var productDescription = document.querySelector('.product__description');
  if (productDescription) {
      var productDescriptionHeight = productDescription.clientHeight;
      
      if (productDescriptionHeight > 200) {
          var parentDetails = productDescription.closest('details');
          if (parentDetails) {
              parentDetails.classList.remove('active');
          }
          
          var readMoreLessWrapper = document.querySelector('.read-more-less-wrapper');
          if (readMoreLessWrapper) {
              readMoreLessWrapper.classList.remove('hidden');
          }
      }
  }

  /* Collection Description read more hide-show */
  var collectionDescription = document.querySelector('.collection__description');
  if (collectionDescription) {
      var collectionDescriptionHeight = collectionDescription.clientHeight;
      
      if (collectionDescriptionHeight > 200) {
          collectionDescription.classList.remove('active');
          
          var readMoreLessWrapper = document.querySelector('.read-more-less-wrapper');
          if (readMoreLessWrapper) {
              readMoreLessWrapper.classList.remove('hidden');
          }
      }
  }

  var singleProductTabProductDescription = document.querySelector(".single-product-tabs .product__description");

  if (singleProductTabProductDescription) {
      var getCurrentLanguage = document.body.getAttribute("data-current-language");

      var showText = singleProductTabProductDescription.getAttribute("data-more");
      var hideText = singleProductTabProductDescription.getAttribute("data-less");

      var descriptionLink = document.querySelector(".description-translation-text a");

      if (descriptionLink) {
          descriptionLink.addEventListener("click", function(e) {
              e.preventDefault();

              var enText = this.getAttribute("data-en-text");
              var fiText = this.getAttribute("data-fi-text");
              var nonTranslatedDescription = document.querySelector(".description-non-translated-description");
              var translatedDescription = document.querySelector(".description-translated-description");
              var readMoreLessWrapper = document.querySelector(".read-more-less-wrapper");

              if (this.classList.contains("displayed-en")) {
                  this.classList.remove("displayed-en");
                  this.textContent = enText;

                  if (nonTranslatedDescription) {
                      nonTranslatedDescription.style.display = "none";
                  }
                  if (translatedDescription) {
                      translatedDescription.style.display = "block";
                  }
                  if (readMoreLessWrapper) {
                      readMoreLessWrapper.classList.remove("custom-hide");
                  }
              } else {
                  this.classList.add("displayed-en");
                  this.textContent = fiText;

                  if (translatedDescription) {
                      translatedDescription.style.display = "none";
                  }
                  if (nonTranslatedDescription) {
                      nonTranslatedDescription.style.display = "block";
                  }
                  if (readMoreLessWrapper) {
                      readMoreLessWrapper.classList.add("custom-hide");
                  }
              }
          });
      }
  }


  /* Collection Page Read More Less */
  document.body.addEventListener('click', function(event) {
      var readMoreLessButton = event.target.closest('.collection-read-more-less');
      
      if (readMoreLessButton) {
          var collectionTitle = readMoreLessButton.closest('.collection-title');
          
          if (collectionTitle) {
              var collectionDescription = collectionTitle.querySelector('.collection__description');
              if (collectionDescription) {
                  collectionDescription.classList.toggle('active');
              }
          }
      }
  });
  
  
});



function checkCartForDifferentVariants() {
  fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
          const productVariants = {};

          cart.items.forEach(item => {
              const productId = item.product_id;
              const variantId = item.variant_id;

              if (!productVariants[productId]) {
                  productVariants[productId] = new Set();
              }
              productVariants[productId].add(variantId);
          });

          let hasMultipleVariants = false;
          for (const productId in productVariants) {
              if (productVariants[productId].size > 1) {
                  hasMultipleVariants = true;
                  break;
              }
          }

          const element = document.getElementById('drawer-cart');
          if (hasMultipleVariants) {
              if (element) {
                  element.classList.add('cart-drawer__notice');
              }
          } else {
              element.classList.remove('cart-drawer__notice');
          }

      })
      .catch(error => {
          console.error('Error fetching cart data:', error);
      });
}

window.addEventListener('DOMContentLoaded', () => {
  checkCartForDifferentVariants();
});

document.addEventListener('cart:update', () => {
  checkCartForDifferentVariants();
});


if (window.screen.width > 767) {
  var searchButton = document.querySelector(".search-button");

  if (searchButton) {
      searchButton.addEventListener("click", function() {
          var drawerSearch = document.querySelector("#drawer-search");

          if (drawerSearch) {
              drawerSearch.classList.add("is-open");
              document.body.classList.add("drawer-search-open");
          }
      });
  }
}

document.addEventListener("DOMContentLoaded", function() {
  const collectionButtonWrappers = document.querySelectorAll('.collection-button-wrapper a');

  collectionButtonWrappers.forEach(collectionButton => {
      collectionButton.addEventListener('click', function(event) {
          event.preventDefault();

          const targetId = this.getAttribute('href').substring(1);
          const targetElement = document.getElementById(targetId);

          if (targetElement) {
              targetElement.scrollIntoView({ behavior: 'smooth' });
          }
      });
  });
});

document.body.addEventListener('change', function(event) {
    if (event.target.matches('.js.product-form__input input[type="radio"]')) {
        var dataVariantId = document.querySelector('.custom-product-form input[name="id"]').value;
        
        document.querySelectorAll('.variant-pre-order').forEach(function(element) {
            element.classList.add('hidden');
        });
        
        var targetElement = document.querySelector('.variant-pre-order[data-id="' + dataVariantId + '"]');
        if (targetElement) {
            targetElement.classList.remove('hidden');
        }
    }
});

/**  Annoucement Bar JS 
const siteHeader = document.querySelector('.site-header');
const announcementsBars = document.querySelectorAll('.announcements-bar');
const activeDropdownMenus = document.querySelectorAll('.main-navigation .main-menu-item.is-open > .dropdown-menu');
if (siteHeader && announcementsBars.length && activeDropdownMenus.length) {
    activeDropdownMenus.forEach((activeDropdownMenu) => {
        announcementsBars.forEach((announcementsBar) => {
            const announcementsBarPosition = siteHeader.compareDocumentPosition(announcementsBar);
            if ((announcementsBarPosition & Node.DOCUMENT_POSITION_FOLLOWING) && window.innerWidth > 767) {
                const dropdownHeight = activeDropdownMenu.offsetHeight;
                announcementsBar.style.marginTop = `${dropdownHeight}px`;
            } else {
                announcementsBar.style.marginTop = '';
            }
        });
    });
}**/

document.querySelectorAll('button[data-menu-trigger]').forEach(function(button) {
    button.addEventListener('click', function() {
        const parentLi = button.closest('li');
        if (parentLi) {
            // Toggle the 'hover' class on the parent <li>
            parentLi.classList.toggle('hover');
            // Add focusout event listener to the document
            document.addEventListener('focusin', function handleFocusOutside(event) {
                const subDropdown = parentLi.querySelector('.sub-dropdown-wrapper');
                
                // If the focus is outside the sub-dropdown-wrapper and the button
                if (subDropdown && !subDropdown.contains(event.target) && !button.contains(event.target)) {
                    parentLi.classList.remove('hover'); // Remove hover class
                    document.removeEventListener('focusin', handleFocusOutside); // Remove the event listener after it runs
                }
            });
        }
    });
});

document.addEventListener('click', function(event) {
    document.querySelectorAll('li.has-sub-dropdown').forEach(function(parentLi) {
        const subDropdown = parentLi.querySelector('.sub-dropdown-wrapper');
        const button = parentLi.querySelector('button[data-menu-trigger]');
        
        // Check if the click is outside of the sub-dropdown and button
        if (subDropdown && !subDropdown.contains(event.target) && !button.contains(event.target)) {
            parentLi.classList.remove('hover');
        }
    });
});

const hoverElements = document.querySelectorAll('.has-sub-dropdown');
let hoverTimeout;
hoverElements.forEach(element => {
    element.addEventListener('mouseover', () => {
        clearTimeout(hoverTimeout);
        hoverTimeout = setTimeout(() => {
            // Remove 'hovered' class from all elements
            hoverElements.forEach(el => el.classList.remove('hover'));
            // Add 'hovered' class to the hovered element
            element.classList.add('hover');
        }, 100); // 1 second
    });
    element.addEventListener('mouseout', () => {
        clearTimeout(hoverTimeout);
        element.classList.remove('hover');
    });
});